import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import { responseError } from '@/utils/errors';
import ErrorToast from '@/components/toasts/ErrorToast';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import actions from '../constants';

export function* updateDatasetDataModelErrorToast(action) {
  yield call(showToast, <ErrorToast
    operation="actions.update"
    name={action.name}
    error={responseError(action).message}
  />);
}

export function* updateDatasetDataModelSuccessToast({ name }) {
  yield call(showToast, <UpdatedToast name={name} />);
}

export default function* datasetDataModelToasts() {
  yield takeEvery(actions.UPDATE_DATASET_DATA_MODEL_ERROR, updateDatasetDataModelErrorToast);
  yield takeEvery(actions.UPDATE_DATASET_DATA_MODEL_SUCCESS, updateDatasetDataModelSuccessToast);
}
